module.exports = __webpack_public_path__ + "neumobot.png?836c5ee13b766ac291cb8d97e7f207c1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/neumobot.png
// module id = 734
// module chunks = 0